import { render, staticRenderFns } from "./Slides.vue?vue&type=template&id=f651f6ea&scoped=true&"
import script from "./Slides.vue?vue&type=script&lang=js&"
export * from "./Slides.vue?vue&type=script&lang=js&"
import style0 from "./Slides.vue?vue&type=style&index=0&id=f651f6ea&scoped=true&lang=css&"
import style1 from "./Slides.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f651f6ea",
  null
  
)

export default component.exports